/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Neznámé`
};

const da_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Ukendt`
};

const de_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Unbekannt`
};

const en_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Unknown`
};

const es_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Desconocido`
};

const fr_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Inconnu`
};

const hu_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Ismeretlen`
};

const it_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Sconosciuto`
};

const nl_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Onbekend`
};

const pl_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Nieznany`
};

const pt_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Desconhecido`
};

const sv_order_states_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Okänd`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const order_states_unknown = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_states_unknown(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_states_unknown", locale)
	if (locale === "cs") return cs_order_states_unknown(inputs)
	if (locale === "da") return da_order_states_unknown(inputs)
	if (locale === "de") return de_order_states_unknown(inputs)
	if (locale === "en") return en_order_states_unknown(inputs)
	if (locale === "es") return es_order_states_unknown(inputs)
	if (locale === "fr") return fr_order_states_unknown(inputs)
	if (locale === "hu") return hu_order_states_unknown(inputs)
	if (locale === "it") return it_order_states_unknown(inputs)
	if (locale === "nl") return nl_order_states_unknown(inputs)
	if (locale === "pl") return pl_order_states_unknown(inputs)
	if (locale === "pt") return pt_order_states_unknown(inputs)
	return sv_order_states_unknown(inputs)
};
export { order_states_unknown as "order_states.unknown" }